import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_21053508 from 'nuxt_plugin_plugin_21053508' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_workbox_1de1f9a4 from 'nuxt_plugin_workbox_1de1f9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_185209f6 from 'nuxt_plugin_nuxticons_185209f6' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_nuxtmq_7638e1cc from 'nuxt_plugin_nuxtmq_7638e1cc' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_vuescrollto_7fc47337 from 'nuxt_plugin_vuescrollto_7fc47337' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_libmodulepluginclient6afc69cb_2ef71dfd from 'nuxt_plugin_libmodulepluginclient6afc69cb_2ef71dfd' // Source: ./lib.module.plugin.client.6afc69cb.js (mode: 'client')
import nuxt_plugin_axios_074eea92 from 'nuxt_plugin_axios_074eea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginclient_e6cfda10 from 'nuxt_plugin_pluginclient_e6cfda10' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_1b5cf700 from 'nuxt_plugin_pluginserver_1b5cf700' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_moment_1d8c0d74 from 'nuxt_plugin_moment_1d8c0d74' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_gtm_b665a430 from 'nuxt_plugin_gtm_b665a430' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_foundation_4465ce4f from 'nuxt_plugin_foundation_4465ce4f' // Source: ../../../src/plugins/client-only/foundation.client (mode: 'client')
import nuxt_plugin_aos_4384ab0b from 'nuxt_plugin_aos_4384ab0b' // Source: ../../../src/plugins/client-only/aos.client (mode: 'client')
import nuxt_plugin_vuelazyload_161ce241 from 'nuxt_plugin_vuelazyload_161ce241' // Source: ../../../src/plugins/client-only/vue-lazyload.client (mode: 'client')
import nuxt_plugin_localStorage_67073d92 from 'nuxt_plugin_localStorage_67073d92' // Source: ../../../src/plugins/client-only/localStorage.client (mode: 'client')
import nuxt_plugin_cookiestorage_01af1ce0 from 'nuxt_plugin_cookiestorage_01af1ce0' // Source: ../../../src/plugins/client-only/cookie-storage.client (mode: 'client')
import nuxt_plugin_serviceworker_2e2d8f8c from 'nuxt_plugin_serviceworker_2e2d8f8c' // Source: ../../../src/plugins/client-only/service-worker.client (mode: 'client')
import nuxt_plugin_ga_30aa9548 from 'nuxt_plugin_ga_30aa9548' // Source: ../../../src/plugins/client-only/ga.client (mode: 'client')
import nuxt_plugin_vuenotifications_25be5c6f from 'nuxt_plugin_vuenotifications_25be5c6f' // Source: ../../../src/plugins/client-only/vue-notifications.client (mode: 'client')
import nuxt_plugin_logger_51ebea11 from 'nuxt_plugin_logger_51ebea11' // Source: ../../../src/plugins/client-only/logger.client (mode: 'client')
import nuxt_plugin_vuescrollto_64d2b252 from 'nuxt_plugin_vuescrollto_64d2b252' // Source: ../../../src/plugins/client-only/vue-scrollto.client (mode: 'client')
import nuxt_plugin_pagetop_2581f2ac from 'nuxt_plugin_pagetop_2581f2ac' // Source: ../../../src/plugins/client-only/page-top.client (mode: 'client')
import nuxt_plugin_axios_4dee9e45 from 'nuxt_plugin_axios_4dee9e45' // Source: ../../../src/plugins/server-client/axios (mode: 'all')
import nuxt_plugin_nuxtmq_67f814f7 from 'nuxt_plugin_nuxtmq_67f814f7' // Source: ../../../src/plugins/nuxt-mq (mode: 'all')
import nuxt_plugin_vue2perfectscrollbar_b52f0648 from 'nuxt_plugin_vue2perfectscrollbar_b52f0648' // Source: ../../../src/plugins/vue2-perfect-scrollbar (mode: 'all')
import nuxt_plugin_vuerellax_96d108b0 from 'nuxt_plugin_vuerellax_96d108b0' // Source: ../../../src/plugins/vue-rellax (mode: 'all')
import nuxt_plugin_window_2e83f2f2 from 'nuxt_plugin_window_2e83f2f2' // Source: ../../../src/plugins/window (mode: 'all')
import nuxt_plugin_gtm_6e03742e from 'nuxt_plugin_gtm_6e03742e' // Source: ../../../src/plugins/gtm (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"refreshOnceOnNavigation":true,"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"prefix":"og: http:\u002F\u002Fogp.me\u002Fns#","lang":"en"},"titleTemplate":"%s｜ Nuxtation","meta":[{"charset":"utf-8"},{"name":"HandheldFriendly","content":"True"},{"http-equive":"x-ua-compatible","content":"ie=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"og:site_name","content":"Nuxtation"},{"hid":"description","name":"description","content":"A description for your site here, this will show on the home page."},{"name":"format-detection","content":"telephone=no, email=no, address=no"},{"hid":"description","name":"description","content":"This is a sample site that applies Foundation to Nuxt.js."},{"hid":"og:site_name","property":"og:site_name","content":"Nuxtation"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fnuxtation.phantomoon.com\u002F"},{"hid":"og:title","property":"og:title","content":"Nuxtation"},{"hid":"og:description","property":"og:description","content":"This is a sample site that applies Foundation to Nuxt.js."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fassets\u002Fimg\u002Fogp\u002Fcommon.png"},{"property":"og:image:width","content":"740"},{"property":"og:image:heith","content":"300"},{"name":"twitter:site","content":"Nuxtation"},{"name":"twitter:card","content":"summary_large_image"},{"property":"article:publisher","content":"FacebookURL"},{"property":"fb:app_id","content":"FacebookAppID"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Nuxtation"},{"hid":"author","name":"author","content":"annrie"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Ffork-awesome@1.1.7\u002Fcss\u002Ffork-awesome.min.css","integrity":"sha256-gsmEoJAws\u002FKd3CjuOQzLie5Q3yshhvmo7YNtBG7aaEY=","crossorigin":"anonymous"},{"hid":"canonical","rel":"canonical","href":"https:\u002F\u002Fnuxtation.phantomoon.com"},{"rel":"icon","sizes":"32x32","type":"image\u002Fpng","href":"\u002Fimg\u002Ffavicon-32x32.png"},{"rel":"icon","sizes":"96x96","type":"image\u002Fpng","href":"\u002Fimg\u002Ffavicon-96x96.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-icon-180.png"},{"rel":"apple-touch-icon","sizes":"167x167","href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-icon-167.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-icon-152.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-icon-120.png"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2048-2732.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2732-2048.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1668-2388.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2388-1668.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1668-2224.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2224-1668.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1536-2048.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2048-1536.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1242-2688.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2688-1242.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1125-2436.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2436-1125.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-828-1792.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1792-828.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1242-2208.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-2208-1242.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-750-1334.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1334-750.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-640-1136.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","rel":"apple-touch-startup-image"},{"href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fapple-splash-1136-640.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","rel":"apple-touch-startup-image"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.daf4ca7f.json"},{"rel":"shortcut icon","href":"https:\u002F\u002Fnuxtation.phantomoon.com\u002Fimg\u002Fsplashscreens\u002Fmanifest-icon-192.png"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"title":"Nuxtation"},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_21053508 === 'function') {
    await nuxt_plugin_plugin_21053508(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_1de1f9a4 === 'function') {
    await nuxt_plugin_workbox_1de1f9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_185209f6 === 'function') {
    await nuxt_plugin_nuxticons_185209f6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_7638e1cc === 'function') {
    await nuxt_plugin_nuxtmq_7638e1cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_7fc47337 === 'function') {
    await nuxt_plugin_vuescrollto_7fc47337(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libmodulepluginclient6afc69cb_2ef71dfd === 'function') {
    await nuxt_plugin_libmodulepluginclient6afc69cb_2ef71dfd(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_074eea92 === 'function') {
    await nuxt_plugin_axios_074eea92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_e6cfda10 === 'function') {
    await nuxt_plugin_pluginclient_e6cfda10(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_1b5cf700 === 'function') {
    await nuxt_plugin_pluginserver_1b5cf700(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_1d8c0d74 === 'function') {
    await nuxt_plugin_moment_1d8c0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_b665a430 === 'function') {
    await nuxt_plugin_gtm_b665a430(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_foundation_4465ce4f === 'function') {
    await nuxt_plugin_foundation_4465ce4f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_4384ab0b === 'function') {
    await nuxt_plugin_aos_4384ab0b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_161ce241 === 'function') {
    await nuxt_plugin_vuelazyload_161ce241(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_67073d92 === 'function') {
    await nuxt_plugin_localStorage_67073d92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookiestorage_01af1ce0 === 'function') {
    await nuxt_plugin_cookiestorage_01af1ce0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_serviceworker_2e2d8f8c === 'function') {
    await nuxt_plugin_serviceworker_2e2d8f8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_30aa9548 === 'function') {
    await nuxt_plugin_ga_30aa9548(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuenotifications_25be5c6f === 'function') {
    await nuxt_plugin_vuenotifications_25be5c6f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logger_51ebea11 === 'function') {
    await nuxt_plugin_logger_51ebea11(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_64d2b252 === 'function') {
    await nuxt_plugin_vuescrollto_64d2b252(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pagetop_2581f2ac === 'function') {
    await nuxt_plugin_pagetop_2581f2ac(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4dee9e45 === 'function') {
    await nuxt_plugin_axios_4dee9e45(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_67f814f7 === 'function') {
    await nuxt_plugin_nuxtmq_67f814f7(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2perfectscrollbar_b52f0648 === 'function') {
    await nuxt_plugin_vue2perfectscrollbar_b52f0648(app.context, inject)
  }

  if (typeof nuxt_plugin_vuerellax_96d108b0 === 'function') {
    await nuxt_plugin_vuerellax_96d108b0(app.context, inject)
  }

  if (typeof nuxt_plugin_window_2e83f2f2 === 'function') {
    await nuxt_plugin_window_2e83f2f2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_6e03742e === 'function') {
    await nuxt_plugin_gtm_6e03742e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
